module.exports = "https://coursera_assets.s3.amazonaws.com/images/2e3bbfd5264527416332bdbc3d012f96.png";